import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createChamp, updateChamp, deleteChamp } from '../../api/CHAMPS/champs';

export const useCreateChamp = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: createChamp,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['champs'] });
    },
  });
};

export const useUpdateChamp = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, champData }) => updateChamp(id, champData),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['champs'] });
      queryClient.invalidateQueries({ queryKey: ['champ', variables.id] });
    },
  });
};

export const useDeleteChamp = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: deleteChamp,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['champs'] });
    },
  });
};
